export default "/_next/static/images/bd6e8ffb91bab02e104d6541a3aa918d.jpg";